// Service Bibliothèque de créatives — galerie réutilisable de l'utilisateur.
import { getRequest, postRequest, patchRequest, deleteRequest } from "./api/apiService";

// Liste paginée (échelle 1000+). params: { type, favorite, q, page, pageSize, scope }
// scope: "mine" (défaut, mes créas) | "library" (Ads Library publique) | "all"
export const fetchCreatives = (params = {}) => getRequest("/api/creatives", params);
export const fetchCreativeCount = (scope) => getRequest("/api/creatives/count", scope ? { scope } : {});

// Enregistre un lot de créatives (appelé après une génération Studio).
export const saveCreatives = (creatives) => postRequest("/api/creatives/bulk", { creatives });

export const toggleFavorite = (id, favorite) => patchRequest(`/api/creatives/${id}`, { favorite });
export const deleteCreative = (id) => deleteRequest(`/api/creatives/${id}`);

// Trace une réutilisation : channel = "ads" | "shopify".
export const markUsed = (id, channel, ref) => postRequest(`/api/creatives/${id}/use`, { channel, ref });
